$(document).ready(function () {

    var divs = ['key-highlights', 'additional-feature'];

    function init() {
        divs.forEach(function (item, index) {
            $(document).on('click', '.add-' + item, function () {
                var div = $('.' + item + '-row');
                var clone = div.last().clone();
                clone.find('input:not(.hidden-field)').val('');
                div.last().after(clone);

                div.addClass('sort-index-' + index++);

                iterate(item);
            });
            $(document).on('click', '.delete-' + item, function () {
                if ($('.' + item + '-row').length === 1) {
                    $(this).closest('.' + item + '-row').find('input').val('');
                } else {
                    $(this).closest('.' + item + '-row').remove();
                    var keyheightrow = $('.key-highlights-row');
                    var key_height_row = keyheightrow.first();
                    key_height_row.find('.key-highlights').trigger("change");
                }
                iterate(item);
            });

        });
    }

    var iterate = function (item) {
        var rows = $('.' + item + '-row');
        var rowsTotal = rows.length;
        var limit = rows.first().data('limit');

        if (!limit) limit = 6;

        rows.each(function (i) {
            if (rowsTotal > (i + 1)) {
                $(this).find('.add-' + item).addClass('hide');
            } else if (rowsTotal === (i + 1)) {
                if (rowsTotal < limit) {
                    $(this).find('.add-' + item).removeClass('hide');
                } else {
                    $(this).find('.add-' + item).addClass('hide');
                }
            }

            if (i > 0) {
                $(this).find('.delete-' + item).removeClass('hide');
            }
        });
    };

    init();
});